import * as stylex from '@stylexjs/stylex';
import '~styles/theme.stylex';
import { colors, radius, font } from '~styles/theme.stylex';
export const styles = {
  icon: {
    color: "x1yam35l",
    $$css: true
  },
  row: {
    display: "x78zum5",
    alignItems: "x6s0dn4",
    gap: "x8233eu",
    rowGap: null,
    columnGap: null,
    $$css: true
  },
  code: {
    flexShrink: "x2lah0s",
    borderRadius: "x1w8o7ox",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    borderWidth: "xmkeg23",
    borderInlineWidth: null,
    borderInlineStartWidth: null,
    borderLeftWidth: null,
    borderInlineEndWidth: null,
    borderRightWidth: null,
    borderBlockWidth: null,
    borderTopWidth: null,
    borderBottomWidth: null,
    borderStyle: "x1y0btm7",
    borderInlineStyle: null,
    borderInlineStartStyle: null,
    borderLeftStyle: null,
    borderInlineEndStyle: null,
    borderRightStyle: null,
    borderBlockStyle: null,
    borderTopStyle: null,
    borderBottomStyle: null,
    borderColor: "x1dw23lg",
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    color: "x1yam35l",
    paddingBlock: "x1bilvtl",
    paddingTop: null,
    paddingBottom: null,
    paddingInline: "x1ryrjj2",
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    fontSize: "xboafo0",
    fontWeight: "xlr2uoh",
    $$css: true
  },
  description: {
    fontSize: "x6u19be",
    lineHeight: "x1evy7pa",
    color: "xtt1gjl",
    $$css: true
  }
};